import React from 'react';
import './style/App.scss';

/* Bootstrap */
import 'bootstrap/dist/css/bootstrap.min.css';

/* Components */
import Navigation from './components/Navigation';
import Main from './components/Main';

const App = () => {
	return (
		<div className="primary" id="top">
			<Navigation />
			<Main />
		</div>
	);
};

export default App;
